import React, { FC, useState, useEffect, useRef, useCallback } from 'react';
import { IconButton, CircularProgress } from '@material-ui/core';
import LocationOn from '@material-ui/icons/LocationOn';
import NotListedLocation from '@material-ui/icons/NotListedLocation';
import { makeStyles } from '@material-ui/core/styles';
import { LocationProvider } from 'providers/locationProvider';
import { SnackbarContainer } from 'components/standalone';
import InfoDialog from 'components/InfoDialog';
import LocationBlockedContent from './LocationBlockedContent';

const useStyles = makeStyles(theme => ({
  yellow: {
    color: theme.palette.warning.main,
  },
}));

const GpsButton: FC = () => {
  const { coords, permissionState, loading, error, requestLocation } =
    LocationProvider.useContainer();
  const { notify } = SnackbarContainer.useContainer();
  const classes = useStyles();
  const [showBlockedModal, setShowBlockedModal] = useState(false);
  const prevPermissionState = useRef<PermissionState | null | undefined>(undefined);
  const prevError = useRef<string | null>(null);

  useEffect(() => {
    if (
      (prevPermissionState.current === 'granted' || prevPermissionState.current === 'prompt') &&
      permissionState === 'denied'
    ) {
      setShowBlockedModal(true);
    }
    prevPermissionState.current = permissionState;
  }, [permissionState]);

  useEffect(() => {
    if (error && error !== prevError.current && permissionState !== 'denied') {
      notify(error, 'error');
    }
    prevError.current = error;
  }, [error, permissionState, notify]);

  const handleClick = useCallback(() => {
    if (permissionState === 'denied') {
      setShowBlockedModal(true);
    } else {
      requestLocation();
    }
  }, [permissionState, requestLocation]);

  let icon: React.ReactNode;

  if (loading) {
    icon = <CircularProgress size={24} color="inherit" />;
  } else if (coords !== null) {
    icon = <LocationOn />;
  } else {
    icon = <NotListedLocation className={classes.yellow} />;
  }

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        {icon}
      </IconButton>
      <InfoDialog
        open={showBlockedModal}
        handleClose={() => setShowBlockedModal(false)}
        title="Location is blocked"
        content={<LocationBlockedContent />}
        closeText="Got it"
      />
    </>
  );
};

export default GpsButton;
